/**
 * @file 相关配置信息
 */
import { FPageConfig, TPlatforms } from '../typings';

export const baseGatewayApi = 'https://uni.xiaowei.cloud.tencent.com';
export const baseGatewayApiTest = 'https://uni.xiaowei.cloud.tencent.com/test';

// prefetch 的相关参数
export const getAppEntryFromConfig = (value: FPageConfig, mode?: string) => {
  const isDEV = mode === 'development';
  if (value.platform === TPlatforms.INDUSTRY_PLATFORM) {
    return {
      name: 'industry-platform-app',
      entry: isDEV ? 'https://tde.xiaowei.cloud.tencent.com/chatbot/' : 'https://xiaowei.cloud.tencent.com/chatbot/',
    };
  }
  if (value.platform === TPlatforms.SMART_CONTACT_CMS) {
    return {
      name: 'smart-contact-cms-index',
      entry: isDEV ? 'https://tde.xiaowei.cloud.tencent.com/chatbot/' : 'https://xiaowei.cloud.tencent.com/chatbot/',
    };
  }
  return null;
};
